var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"px-2 md:px-[7.25rem] xl:px-[15rem]"},[_c('HomeView'),_c('SkillsView'),_c('ContactView'),_c('ProjectsView'),_c('ScrollToUp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }